import type { Context, ReactNode } from 'react';
import { createContext } from 'react';

import type { PublicPluginAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import type { ContextPanelPlugin } from '@atlaskit/editor-plugin-context-panel/contextPanelPluginType';

export type Item = {
	itemName: string;
	component: ReactNode;
	close: () => void;
	hasPadding?: boolean;
	customWidth?: number;
};

export type EditorContextPanelContextValue = {
	item: Item | null;
	setItem: (item: Item) => void;
	removeItem: (itemName: string) => void;
	editorAPI: PublicPluginAPI<[ContextPanelPlugin]> | null | undefined;
};

export const EditorContextPanelContext: Context<EditorContextPanelContextValue> =
	createContext<EditorContextPanelContextValue>({
		item: null,
		setItem: () => {},
		removeItem: () => {},
		editorAPI: undefined,
	});
